var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"btn btn-warning px-5 py-3 rounded-pill fw-semibold font-weight-bold z-2",on:{"click":_vm.handleClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }